import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { Button, Classes, Dialog, FormGroup, H5, HTMLSelect, InputGroup, Popover, Switch } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { toast } from "react-toastify";
import { BootstrapTable, SearchField, TableHeaderColumn, } from "react-bootstrap-table";
import { SpedTabelaStore } from "../../stores/sped/SpedTabelaStore";
import { Pager } from "../utils/Pager";
import { AjusteSpedStore } from "../../stores/admin/AjusteSpedStore";
import { debounce } from "underscore";
import moment from "moment";
import { LookupStore } from "../../stores/LookupStore";
import { ISpedTabela, ISpedTabelas } from "../../model";
import { converterData } from "../../utils";
import IntlCurrencyInput from "react-intl-currency-input";
import { AppIcon } from "../utils/AppIcon";

const currencyConfig = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "decimal",
        useGrouping: false,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

interface State {
  listTabelas: any[];
  listClass: any[];
}

@observer
export class AjusteSped extends React.Component<{}, State> {

  obs = observable({
    open_create: false as boolean,
    id: null as string,
    nome: "" as string,
    uf: "" as string,
    fetchOptions: {} as any,
    open_ajuda: false as boolean,
    dadosTabela: [] as ISpedTabelas[],

    credito: false as boolean,
    debito: false as boolean,

    ajuste_sistema: false as boolean,
    deducoes: false as boolean,
    acrescimo: false as boolean,
    presumido: false as boolean,

    estorno_credito: false as boolean,
    estorno_debito: false as boolean,

    credito_pa: 0 as number

  })

  constructor(props) {
    super(props);

    this.state = {
      listTabelas: [],
      listClass: []
    }

    this.obs.fetchOptions = debounce(this.handleBuscaAjustes.bind(this), 800);

  }

  async componentDidMount() {
    AppStore.setTitle("Ajustes SPED");

    AjusteSpedStore.obs.ajustes_current = 1
    AjusteSpedStore.obs.ajustes_filter = ""

    await AjusteSpedStore.handleBuscaAjustes(AjusteSpedStore.obs.ajustes_current, AjusteSpedStore.obs.ajustes_filter)

  }

  handleOpenCreate() {

    this.obs.id = ""
    this.obs.nome = ""
    this.obs.uf = ""
    this.obs.credito_pa = 0
    this.obs.credito = false
    this.obs.debito = false
    this.obs.ajuste_sistema = false

    this.obs.deducoes = false
    this.obs.acrescimo = false
    this.obs.presumido = false
    this.obs.estorno_credito = false
    this.obs.estorno_debito = false

    SpedTabelaStore.obs.dadosTabela = []
    LookupStore.obs.icms_classificacoes = []

    this.obs.dadosTabela = []

    this.obs.open_create = true

  }

  async handleSave() {

    if (!this.obs.nome) {
      toast.warn("Favor preencha o campo nome!", {})
      return
    }

    if (!this.obs.uf) {
      toast.warn("Favor preencha o campo UF!", {})
      return
    }

    if (!this.state.listTabelas.length) {
      toast.warn("Favor selecione pelo menos uma tabela!", {})
      return
    }

    let data = {
      id: this.obs.id,
      ids_tabelas_sped: this.state.listTabelas,
      ids_classificacoes: this.state.listClass,
      uf: this.obs.uf,
      nome: this.obs.nome,
      credito: this.obs.credito,
      debito: this.obs.debito,
      ajuste_sistema: this.obs.ajuste_sistema,
      deducoes: this.obs.deducoes,
      acrescimo: this.obs.acrescimo,
      presumido: this.obs.presumido,
      estorno_credito: this.obs.estorno_credito,
      estorno_debito: this.obs.estorno_debito,
      credito_pa: this.obs.credito_pa.toString()
    }

    if (!this.obs.id) {

      delete data.id

      await AjusteSpedStore.handleCreateAjustes(data)

    } else {

      await AjusteSpedStore.handleUpdateAjustes(data)

    }

    this.obs.open_create = false

  }

  handleCheckTabelas = async (row, checked) => {

    if (checked) {

      this.setState(state => { state.listTabelas.push(row.id) });

    } else {

      let index = this.state.listTabelas.indexOf(row.id);

      this.state.listTabelas.splice(index, 1);

    }

  };

  handleCheckTabelasAll = async (check, row) => {

    if (check) {

      this.setState({ listTabelas: row?.map(value => value.id) });

    } else {

      this.setState({ listTabelas: [] });
    }

  };

  createCustomSearchFieldSol = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-ajuste"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Código, Descrição)"
      />
    );
  };

  async handleQueryFilters(uf) {

    this.setState({ listTabelas: [], listClass: [] });

    this.obs.dadosTabela = []

    await SpedTabelaStore.handleLoadTabelas("1", uf, true)
    this.obs.dadosTabela = [...SpedTabelaStore.obs.dadosTabela]

    await SpedTabelaStore.handleLoadTabelas("2", uf, true)
    this.obs.dadosTabela = [...this.obs.dadosTabela, ...SpedTabelaStore.obs.dadosTabela]

    await LookupStore.loadIcmsClassificacoes(uf);

    this.obs.uf = uf

  }

  async handleChangePage(page: number) {

    AjusteSpedStore.obs.ajustes_current = page

    await AjusteSpedStore.handleBuscaAjustes(page, AjusteSpedStore.obs.ajustes_filter)

  }

  async handleEditAjuste(row) {

    this.obs.id = row._id
    this.obs.uf = row.uf
    this.obs.nome = row.nome
    this.obs.credito = row.credito ?? false
    this.obs.debito = row.debito ?? false
    this.obs.ajuste_sistema = row.ajuste_sistema ?? false

    this.obs.deducoes = row.deducoes ?? false
    this.obs.acrescimo = row.acrescimo ?? false
    this.obs.presumido = row.presumido ?? false
    this.obs.estorno_credito = row.estorno_credito ?? false
    this.obs.estorno_debito = row.estorno_debito ?? false
    this.obs.credito_pa = row.credito_pa ?? 0

    this.setState({ listTabelas: row.ids_tabelas_sped, listClass: row.ids_classificacoes })

    this.obs.dadosTabela = []

    await SpedTabelaStore.handleLoadTabelas("1", row.uf, true)
    this.obs.dadosTabela = [...SpedTabelaStore.obs.dadosTabela]

    await SpedTabelaStore.handleLoadTabelas("2", row.uf, true)
    this.obs.dadosTabela = [...this.obs.dadosTabela, ...SpedTabelaStore.obs.dadosTabela]

    await LookupStore.loadIcmsClassificacoes(row.uf);

    this.obs.open_create = true

  }

  async handleDeleteAjuste(id) {

    await AjusteSpedStore.handleDeleteAjuste(id)

  }

  handleBuscaFiltered(filtro: string) {

    AjusteSpedStore.obs.ajustes_filter = filtro
    AjusteSpedStore.obs.ajustes_current = 1

    this.obs.fetchOptions()

  }

  async handleBuscaAjustes() {

    await AjusteSpedStore.handleBuscaAjustes(AjusteSpedStore.obs.ajustes_current, AjusteSpedStore.obs.ajustes_filter)

  }

  formaterEstado = (cell, row) => {
    if (!cell) return ""

    return cell.toUpperCase()

  }

  formaterCount = (cell, row) => {

    if (!cell) return ""

    return <b>{cell.length} selecionado(s)</b>

  }

  formaterDate = (cell, row) => {

    if (!cell) return ""

    return moment(cell).add(3, "hours").format("DD/MM/YYYY");

  };

  formaterCredito = (cell, row) => {

    return cell ? "Crédito" : "Débito"

  };

  formaterSaida = (cell, row) => {

    return cell ? "Saída" : "Entrada"

  };

  formaterDetalhes = (cell, row) => {
    return (
      <>
        <MDBBtn color="default" rounded size="sm" onClick={() => this.handleEditAjuste(row)}>
          <img src="/images/edit.png" width={15} />
        </MDBBtn>
        <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
          <MDBBtn color="default" rounded size="sm" >
            <img src="/images/bin.png" width="25px" />

          </MDBBtn>
          <div>
            <H5>Confirmar exclusão?</H5>
            <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 15,
              }}
            >
              <Button
                className={Classes.POPOVER_DISMISS}
                style={{ marginRight: 10 }}
              >
                Cancelar
              </Button>
              <Button
                intent="danger"
                className={Classes.POPOVER_DISMISS}
                onClick={() => this.handleDeleteAjuste(row._id)}
              >
                Excluir
              </Button>
            </div>
          </div>
        </Popover>
      </>
    )
  }

  handleCheckClass = async (row, checked) => {

    if (checked) {

      this.setState(state => { state.listClass.push(row.id) });

    } else {

      let index = this.state.listClass.indexOf(row.id);

      this.state.listClass.splice(index, 1);

    }

  };

  handleCheckClassAll = async (check, row) => {

    if (check) {

      this.setState({ listClass: row?.map(value => value.id) });

    } else {

      this.setState({ listClass: [] });
    }

  };

  onClose() {

    this.obs.open_create = false

    this.setState({ listTabelas: [], listClass: [] });

    this.obs.id = ""
    this.obs.nome = ""
    this.obs.uf = ""
    this.obs.credito_pa = 0
    this.obs.credito = false
    this.obs.debito = false
    this.obs.ajuste_sistema = false
    this.obs.deducoes = false
    this.obs.acrescimo = false
    this.obs.presumido = false
    this.obs.estorno_credito = false
    this.obs.estorno_debito = false

    SpedTabelaStore.obs.dadosTabela = []
    LookupStore.obs.icms_classificacoes = []

    this.obs.dadosTabela = []
  }

  isRegistroValido = (registro: ISpedTabela): boolean => {

    const dataAtual = new Date();
    const dataInicio = converterData(registro.data_inicio);
    const dataFim = converterData(registro.data_fim);

    if (!dataInicio) return false;

    const validoAposInicio = dataAtual >= dataInicio;

    const validoAntesFim = !dataFim || dataAtual <= dataFim;

    return validoAposInicio && validoAntesFim;
  }

  handleCredito(e) {
    this.obs.debito = false
    this.obs.deducoes = false
    this.obs.estorno_debito = false
  }

  handleDebito(e) {
    this.obs.credito = false
    this.obs.acrescimo = false
    this.obs.estorno_credito = false
    this.obs.presumido = false
  }

  isCredito() {

    if (!this.obs.debito && !this.obs.deducoes && !this.obs.estorno_debito) return true

    return false

  }

  render() {

    let tabelas = this.obs.dadosTabela?.filter(this.isRegistroValido).filter(x => this.isCredito() ? x.credito : !x.credito).map(obj => {

      return ({
        id: (obj.id || obj._id),
        codigo: obj.codigo,
        descricao: obj.descricao,
        credito: (obj.credito || false),
      })

    });

    let classificacoes = LookupStore.obs.icms_classificacoes?.map(obj => {

      return ({
        id: (obj.id || obj.id),
        nome: obj.nome,
      })

    });

    const selectRowTabelas = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckTabelas,
      onSelectAll: this.handleCheckTabelasAll,
      selected: this.state.listTabelas,
    };

    const selectRowClass = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckClass,
      onSelectAll: this.handleCheckClassAll,
      selected: this.state.listClass,
    };

    const options = {
      searchField: this.createCustomSearchFieldSol,
    };

    let estadosOption = [
      { label: "Selecione um Estado", value: "" },
      // { label: "AC", value: "ac" },
      // { label: "AL", value: "al" },
      // { label: "AP", value: "ap" },
      // { label: "AM", value: "am" },
      // { label: "BA", value: "ba" },
      // { label: "CE", value: "ce" },
      // { label: "DF", value: "df" },
      // { label: "ES", value: "es" },
      // { label: "GO", value: "go" },
      // { label: "MA", value: "ma" },
      // { label: "MT", value: "mt" },
      // { label: "MS", value: "ms" },
      // { label: "MG", value: "mg" },
      { label: "PA", value: "pa" },
      // { label: "PB", value: "pb" },
      // { label: "PR", value: "pr" },
      // { label: "PE", value: "pe" },
      // { label: "PI", value: "pi" },
      // { label: "RJ", value: "rj" },
      // { label: "RN", value: "rn" },
      { label: "RS", value: "rs" },
      // { label: "RO", value: "ro" },
      // { label: "RR", value: "rr" },
      // { label: "SC", value: "sc" },
      // { label: "SP", value: "sp" },
      // { label: "SE", value: "se" },
      { label: "TO", value: "to" },
    ]

    return (
      <>

        <MDBRow style={{ display: "flex", width: "100%", marginBottom: "10px" }}>
          <MDBCol md="3">
            <InputGroup
              round
              leftIcon="search"
              style={{ borderRadius: 10 }}
              placeholder="Filtrar (Nome)"
              value={AjusteSpedStore.obs.ajustes_filter}
              onChange={(e: any) => this.handleBuscaFiltered(e.target.value)}
            />
          </MDBCol>

          <MDBCol md="3">
            <Button
              text="Criar Ajuste"
              className="btnDefault btnBuscarNfe btnVerde"
              onClick={() => this.handleOpenCreate()}
            />
          </MDBCol>

        </MDBRow>

        <BootstrapTable className="TabelaSimples" data={AjusteSpedStore.obs.ajustes}>
          <TableHeaderColumn dataField="id" width="1%" isKey={true} hidden >#</TableHeaderColumn>
          <TableHeaderColumn dataField="nome" width="60%">Nome</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterCount} dataField="ids_tabelas_sped" width="20%">Tabelas</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterCount} dataField="ids_classificacoes" width="20%">Classificações</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterEstado} dataField="uf" width="20%">Estado</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterCredito} dataField="credito" width="20%">Débito / Crédito</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterDate} dataField="inserted_at" width="20%">Criado em</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterDetalhes} width="20%"></TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={AjusteSpedStore.obs.ajustes_current}
            totalCount={AjusteSpedStore.obs.ajustes_length}
            pageSize={10}
            onPageChange={(page) => this.handleChangePage(page)}
          />
        </div>

        <div style={{ marginBottom: 120 }} />

        <Dialog
          isOpen={this.obs.open_create}
          className="AlertUser modalSefa modalAjusteSped"
          onClose={() => this.onClose()}>
          <h2 className="titleSEFAZ modal-sefa">{!this.obs.id ? "Novo Ajuste" : "Atualizar Ajuste"}</h2>

          <div style={{ display: "flex" }}>
            <FormGroup className="form-group" label="Nome" labelInfo="*" style={{ width: "50%", marginRight: 10 }}>
              <InputGroup type="text" onChange={(e) => this.obs.nome = e.target.value} value={this.obs.nome} />
            </FormGroup>

            <FormGroup className="form-group" label="Estado" labelInfo="*" style={{ width: "50%" }}>
              <HTMLSelect onChange={(e) => this.handleQueryFilters(e.target.value)} value={this.obs.uf}>
                {estadosOption?.map((option) => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </HTMLSelect>
            </FormGroup>

          </div>

          <div style={{ display: "flex" }}>

            <div style={{ width: "33%", display: "flex", flexDirection: "column" }}>
              <Switch
                className="select-regras"
                innerLabelChecked="Crédito"
                innerLabel="Crédito"
                checked={this.obs.credito}
                onChange={(e: any) => this.handleCredito(this.obs.credito = e.target.checked)}
              />

              <Switch
                className="select-regras"
                innerLabelChecked="Débito"
                innerLabel="Débito"
                checked={this.obs.debito}
                onChange={(e: any) => this.handleDebito(this.obs.debito = e.target.checked)}
              />
            </div>

            <div style={{ width: "33%", display: "flex", flexDirection: "column" }}>

              <div style={{ display: "flex", alignItems: "center", }}>
                <Switch
                  className="select-regras"
                  innerLabelChecked="Ajuste Sistema"
                  innerLabel="Ajuste Sistema"
                  checked={this.obs.ajuste_sistema}
                  onChange={(e: any) => this.obs.ajuste_sistema = e.target.checked}
                />
                <AppIcon
                  name="help"
                  className="pulse-notification-pgdas"
                  color="blue"
                  style={{ cursor: "pointer", marginBottom: 10 }}
                  onClick={() => this.obs.open_ajuda = true}
                />
              </div>

              <Switch
                className="select-regras"
                innerLabelChecked="Deduções"
                innerLabel="Deduções"
                checked={this.obs.deducoes}
                onChange={(e: any) => this.handleDebito(this.obs.deducoes = e.target.checked)}
              />
            </div>

            <div style={{ width: "33%", display: "flex", flexDirection: "column" }}>
              <Switch
                className="select-regras"
                innerLabelChecked="Acréscimos"
                innerLabel="Acréscimos"
                checked={this.obs.acrescimo}
                onChange={(e: any) => this.handleCredito(this.obs.acrescimo = e.target.checked)}
              />

              <Switch
                className="select-regras"
                innerLabelChecked="Crédito presumido"
                innerLabel="Crédito presumido"
                checked={this.obs.presumido}
                onChange={(e: any) => this.handleCredito(this.obs.presumido = e.target.checked)}
              />
            </div>

            <div style={{ width: "33%", display: "flex", flexDirection: "column" }}>
              <Switch
                className="select-regras"
                innerLabelChecked="Estorno de créditos"
                innerLabel="Estorno de créditos"
                checked={this.obs.estorno_credito}
                onChange={(e: any) => this.handleCredito(this.obs.estorno_credito = e.target.checked)}
              />

              <Switch
                className="select-regras"
                innerLabelChecked="Estorno de débitos"
                innerLabel="Estorno de débitos"
                checked={this.obs.estorno_debito}
                onChange={(e: any) => this.handleDebito(this.obs.estorno_debito = e.target.checked)}
              />

            </div>

          </div>

          {this.obs.presumido &&
            <FormGroup label="Crédito PA">
              <div style={{ position: "relative" }}>
                <IntlCurrencyInput
                  className="form-control"
                  onChange={(event, value, maskedValue) => this.obs.credito_pa = value}
                  value={this.obs.credito_pa}
                  currency="BRL"
                  config={currencyConfig}
                  style={{ paddingRight: "24px" }}
                />
                <span style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: "#666", fontSize: 18 }}>
                  %
                </span>
              </div>
            </FormGroup>
          }

          {this.obs.uf && <>
            <FormGroup label="Selecione as Tabelas" labelInfo="*">
              <div className="select-empresa-ajuste">
                <BootstrapTable data={tabelas} selectRow={selectRowTabelas} options={options} search>
                  <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                  <TableHeaderColumn dataField="codigo" width="20%">Código</TableHeaderColumn>
                  <TableHeaderColumn dataField="descricao" width="75%">Descrição</TableHeaderColumn>
                </BootstrapTable>
              </div>
            </FormGroup>

            <FormGroup label="Selecione as Classificações">
              <div className="select-empresa-ajuste">
                <BootstrapTable data={classificacoes} selectRow={selectRowClass} options={options} search>
                  <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                  <TableHeaderColumn dataField="nome" width="90%">Nome</TableHeaderColumn>
                </BootstrapTable>
              </div>
            </FormGroup>
          </>}

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.onClose()} />
            <Button text="Salvar" intent="primary" onClick={() => this.handleSave()} />
          </div>

        </Dialog>

        <Dialog
          isOpen={this.obs.open_ajuda}
          onClose={() => this.obs.open_ajuda = false}
          className="dados-soli"
        >
          <div className={Classes.DIALOG_BODY}>

            <div style={{ fontSize: 12, textAlign: "justify" }}>

              Este ajuste, invisível ao usuário, é essencial para o cálculo. Ele entra em ação quando nenhum ajuste personalizado é definido, garantindo que os cálculos padrão sejam aplicados e a apuração seja realizada.

            </div>

          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_ajuda = false} />
            </div>
          </div>

        </Dialog>

      </>
    );
  }
}